import { createAction } from '@reduxjs/toolkit';

export const THEME_ACTION_TYPES = {
  SET_LOGO: 'SET_LOGO',
};

export const setLogo = createAction<string>(THEME_ACTION_TYPES.SET_LOGO);
